import styled from "styled-components/macro";
import { darkBlue } from "../../../../constants/colors";

export const ChartStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  padding-right: 2%;
  padding-left: 2%;
  border: 2px solid black;
  .chartTitle {
    text-align: center;
    font-size: 1.2em;
    color: ${darkBlue};
    padding: 5px;
  }
  .chartBody {
    box-sizing: border-box;
  }
`;
